import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { MandalListEntity } from "./mandal.entity";

@Entity('100VIllage')
export class VillageListEntity {  
  @PrimaryGeneratedColumn("increment",{name:'Id'})
  Id:number;
 
  @Column("varchar",{
    nullable: false,
    length:500,
    name:"Village_Name"
  })
  Village_Name:string;

  @Column("int",{
    nullable:true,
    name:"Mandalid"
  })
  Mandalid:number;

  @ManyToOne(()=>MandalListEntity, (mandal:MandalListEntity)=>mandal.vill)
  @JoinColumn({name:"Mandalid"})
  mandal:MandalListEntity;
  
}